import {
  vuesaxColors,
  rgbRE,
  rgbNumberRE,
  leadingHashRE,
  hexShorthandRE,
  hexFullRE,
} from '@vuesax-plus/constants'
import type { VuesaxColor } from '@vuesax-plus/constants'

export const isColorDark = (color?: string | boolean): boolean => {
  if (color === undefined || color === false) return false
  return color === 'dark' || color === true
}

export const isVsColor = (color: VuesaxColor): boolean =>
  vuesaxColors.includes(color)

export const hexToRgb = (color: string) => {
  color = color.replace(
    hexShorthandRE,
    (_, r: string, g: string, b: string) => r + r + g + g + b + b
  )
  const res = hexFullRE.exec(color)

  return res
    ? {
        r: parseInt(res[1], 16),
        g: parseInt(res[2], 16),
        b: parseInt(res[3], 16),
      }
    : null
}

/*
   color maybe is hex #fff, rgb rgba, rgb number
   e.g rgb(23,34,34) -> 23, 34, 34
  */
export const getVsColor = (color: string): string => {
  const isRGB = rgbRE.test(color)
  const isRGBNumbers = rgbNumberRE.test(color)
  const isHEX = leadingHashRE.test(color)

  let newColor: string = ''

  if (isRGB) {
    const arrayColor = color.replace(/[rgba()]/g, '').split(',')
    newColor = `${arrayColor[0]},${arrayColor[1]},${arrayColor[2]}`
  } else if (isHEX) {
    const rgb = hexToRgb(color)
    newColor = `${rgb!.r},${rgb!.g},${rgb!.b}`
  } else if (isVsColor(color as VuesaxColor)) {
    const style = window.getComputedStyle(document.body)
    newColor = style.getPropertyValue(`--vs-${color}`)
  } else if (isRGBNumbers) {
    newColor = color
  }
  return newColor
}

export const setVsCssVar = (
  propertyName: string,
  value: string,
  el?: HTMLElement
) => {
  if (!el) {
    document.documentElement.style.setProperty(`--vs-${propertyName}`, value)
  } else {
    if (el.nodeName !== '#comment') {
      el.style.setProperty(`--vs-${propertyName}`, value)
    }
  }
}
